import { Numeric } from '@blade/ui-kit'

import {
  COUNT_MAX_3_DIGITS_PRESET,
  COUNT_MAX_5_DIGITS_PRESET,
  CURRENCY_AMOUNT_NATIVE_PRESET,
  MCAP_LIQ_VOL_SHORT_PRESET,
  PNL_USD_PRESET,
  PRICE_PRESET,
  TX_COUNT_PRESET,
  HOLDERS_COUNT_PRESET,} from './numeric-presets'

import type { ClassNameProps, StyleProps } from '@root/shared/react'
import type BigNumber from 'bignumber.js'

export const MarkerCapShortFormatted = ({ mcap }: { mcap: BigNumber }) => {
  return (
    <Numeric value={mcap} preset={MCAP_LIQ_VOL_SHORT_PRESET} currency="$" />
  )
}

export const LiquidityShortFormatted = ({
  liquidity,
  className,
  style,
}: {
  liquidity: BigNumber
} & ClassNameProps &
  StyleProps) => {
  return (
    <Numeric
      value={liquidity}
      preset={MCAP_LIQ_VOL_SHORT_PRESET}
      currency="$"
      className={className}
      style={style}
    />
  )
}

export const VolumeShortFormatted = ({ volume }: { volume: BigNumber }) => {
  return (
    <Numeric value={volume} preset={MCAP_LIQ_VOL_SHORT_PRESET} currency="$" />
  )
}

export const PnlUsdFormatted = ({ pnl }: { pnl: BigNumber }) => {
  return <Numeric forceSign value={pnl} preset={PNL_USD_PRESET} currency="$" />
}

export const TxCountFormatted = ({ txCount }: { txCount: BigNumber.Value }) => {
  return <Numeric value={txCount} preset={TX_COUNT_PRESET} />
}

export const CountMax5DigitsFormatted = ({
  count,
}: {
  count: BigNumber.Value
}) => {
  return <Numeric value={count} preset={COUNT_MAX_5_DIGITS_PRESET} />
}

export const HoldersCountFormatted = ({
  count,
}: {
  count: BigNumber.Value
}) => {
  return <Numeric value={count} preset={HOLDERS_COUNT_PRESET} />
}

export const CountMax3DigitsFormatted = ({
  count,
}: {
  count: BigNumber.Value
}) => {
  return <Numeric value={count} preset={COUNT_MAX_3_DIGITS_PRESET} />
}
export const AmountNativeFormatted = ({
  amount,
  currency,
}: {
  amount: BigNumber
  currency?: string
}) => {
  return (
    <Numeric
      value={amount}
      preset={CURRENCY_AMOUNT_NATIVE_PRESET}
      currency={currency}
    />
  )
}

export const PriceFormatted = ({
  price,
  currency,
}: {
  price: BigNumber.Value
  currency: string
}) => {
  return <Numeric value={price} preset={PRICE_PRESET} currency={currency} />
}

export const AmountFormatted = ({
  amount,
  currency,
  roundingMode = 'halfExpand',
}: {
  amount: BigNumber.Value
  currency?: string
  roundingMode?: 'halfExpand' | 'trunc'
}) => {
  return (
    <Numeric
      value={amount}
      preset={PRICE_PRESET}
      currency={currency}
      roundingMode={roundingMode}
    />
  )
}
